import { render, staticRenderFns } from "./AsideMenuOpenButton.vue?vue&type=template&id=a564b40e"
import script from "./AsideMenuOpenButton.vue?vue&type=script&lang=ts"
export * from "./AsideMenuOpenButton.vue?vue&type=script&lang=ts"
import style0 from "./AsideMenuOpenButton.vue?vue&type=style&index=0&id=a564b40e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports